import React from "react";
import { Table } from "react-bootstrap";
import JobStatusBadge from "app/components/common/JobStatusBadge";
import { formatListDate, formatListTime } from "../utils/dateFormat";

// Desktop table (rendered by the list only when device.isDesktop, >1024px).
const JobsTable = ({ jobs, onRowClick }) => (
  <Table hover responsive className="jobs-table">
    <thead>
      <tr>
        <th>Date</th>
        <th>Address &amp; Client</th>
        <th>Inspection</th>
        <th>Contract</th>
        <th>Payment</th>
        <th>Email</th>
      </tr>
    </thead>
    <tbody>
      {jobs.map((job) => (
        <tr
          key={job.id}
          className="jobs-table-row"
          onClick={() => onRowClick(job.id)}
        >
          <td className="jobs-cell-date">
            <div className="jobs-cell-date-day">{formatListDate(job.date)}</div>
            <div className="jobs-cell-date-time">
              {formatListTime(job.start_time)}
            </div>
          </td>
          <td>
            <div className="jobs-cell-address" title={job.address}>
              {job.address}
            </div>
            {job.client_name && (
              <div className="jobs-cell-client">{job.client_name}</div>
            )}
          </td>
          <td>
            <JobStatusBadge domain="inspection" value={job.inspection_status} />
          </td>
          <td>
            <JobStatusBadge domain="contract" value={job.contract_status} />
          </td>
          <td>
            <JobStatusBadge domain="payment" value={job.payment_status} />
          </td>
          <td>
            <JobStatusBadge
              domain="email"
              value={job.email_aggregate?.key}
              count={job.email_aggregate?.count}
            />
          </td>
        </tr>
      ))}
    </tbody>
  </Table>
);

export default JobsTable;
